import styled from "styled-components";

export const LoadingWrapper = styled.div`
  width: 100%;
  display: flex;
`;

export const ProviderModalContent = styled.div``;

export const ProviderModalForm = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;

  textarea {
    padding: 1rem;
  }

  > div:first-of-type {
    margin-right: 0.5rem;
  }

  > div:last-of-type {
    margin-left: 0.5rem;
  }

  button:last-of-type {
    width: 9.75rem;
    height: 3rem;
    margin-left: auto;
    background-color: var(--primary);
    margin-right: 2rem;
    &:disabled {
      background: var(--grey-200) !important;
      color: var(--grey-300);
      cursor: default;
    }
  }
`;

export const ProviderModalData = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  input {
    margin-bottom: 1rem !important;
  }

  small {
    margin-top: -0.5rem;
    margin-bottom: 1rem;
  }

  .service-input {
    width: 100%;
    select,
    input {
      width: 100%;
    }
  }
`;

export const TextAreaContainer = styled.div`
  margin-top:16px;
  width: 100%;

  label {
    font-style: normal;
    font-weight: normal;
    line-height: 24px;
    font-size: 16px;
    color: var(--grey-100);
    margin-bottom: 0.75rem;
  }

  textarea {
    width: 100%;
    height: 250px;
    background: var(--black-100);
    border-radius: 4px;
  }
  small {
    color: rgb(255, 101, 101);
    font-size: 13.5px;
    font-family: "IBM Plex Sans";
    line-height: 12px;
    margin: 8px 0;
  }
`;

export const AddedServices = styled.div`
  display:flex;
  flex-direction: column;
  width:100%;
  margin-top:16px;
  margin:auto;
  margin-top:5px;
  label {
    margin-left:95px;
    margin-bottom:16px;
    font-style: normal;
    font-weight: normal;
    font-size: 0.9rem;
    color: var(--grey-100);
  }
  div {
    width: 80%;
    margin:auto;
    display:flex;
    flex-direction:row;
    justify-content: space-between;
    background-color:var(--black-400);
    height: 40px;
    border-bottom: 1px solid #3d3d3d;
    color: var(--grey-100);
    font-family: Inter, sans-serif;
    font-size: 0.9rem;
    &:hover {
      cursor: pointer;
    }
    &:first-of-type {
      border-radius:4px 4px 0 0 ;
    }
    &:last-of-type {
      border-radius:0 0 4px 4px  ;
      border-bottom: none;
    }
    span {
      margin:auto 20px auto 20px;
    }
  }
`;


export const AddButton = styled.div`
  width: 100%;
  button {
    margin-top: 1rem;
    width: 100% !important;
  }
`